// extracted by mini-css-extract-plugin
export var container = "_j5-0";
export var content = "_j5-3";
export var customerTitle = "_j5-4";
export var empty = "_j5-5";
export var gray = "_j5-6";
export var header = "_j5-7";
export var info = "_j5-8";
export var loading = "_j5-2";
export var loadingCard = "_j5-9";
export var oneLine = "_j5-a";
export var personName = "_j5-e";
export var pillContainer = "_j5-b";
export var selected = "_j5-1";
export var text = "_j5-c";
export var twoLines = "_j5-d";
export var unread = "_j5-f";
export var unreadIndicator = "_j5-g";